import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnLC: CultureInfo = {
  name: 'en-LC',
  displayName: 'English (St. Lucia)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-LC',
  parent: CultureInfoEn
};
